"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectiveObjectReuse = void 0;
var isNonNullObject = function (value) {
    return !!value && typeof value === 'object';
};
var isSpecial = function (value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]';
};
var isDate = function (value) {
    return Object.prototype.toString.call(value) === '[object Date]';
};
var isRegExp = function (value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
};
var updateEntry = function (newEntry, oldEntry) {
    if (newEntry === oldEntry) {
        return [oldEntry, true];
    }
    if (!isNonNullObject(newEntry) || !isNonNullObject(oldEntry)) {
        return [newEntry, false];
    }
    if (isDate(newEntry) && isDate(oldEntry)) {
        if (newEntry.toString() === oldEntry.toString()) {
            return [oldEntry, true];
        }
        else {
            return [newEntry, false];
        }
    }
    if (isRegExp(newEntry) && isRegExp(oldEntry)) {
        if (newEntry.toString() === oldEntry.toString()) {
            return [oldEntry, true];
        }
        else {
            return [newEntry, false];
        }
    }
    if (isSpecial(newEntry) || isSpecial(oldEntry) || Object.isFrozen(newEntry)) {
        return [newEntry, false];
    }
    var newEntryObject = newEntry;
    var oldEntryObject = oldEntry;
    var newEntryKeys = Object.keys(newEntryObject);
    var oldEntryKeys = Object.keys(oldEntryObject);
    var entriesAreEqual = newEntryKeys.length === oldEntryKeys.length;
    if (entriesAreEqual && !newEntryKeys.length && Array.isArray(newEntry) !== Array.isArray(oldEntry)) {
        entriesAreEqual = false;
    }
    newEntryKeys.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(oldEntryObject, key)) {
            var result = updateEntry(newEntryObject[key], oldEntryObject[key]);
            if (result[1]) {
                newEntryObject[key] = result[0];
            }
            else {
                entriesAreEqual = false;
            }
        }
    });
    if (entriesAreEqual) {
        return [oldEntryObject, true];
    }
    else {
        return [newEntryObject, false];
    }
};
var SelectiveObjectReuse = /** @class */ (function () {
    function SelectiveObjectReuse() {
        this.stack = {};
    }
    SelectiveObjectReuse.prototype.wrap = function (newEntry, namespace) {
        if (namespace === void 0) { namespace = 'default'; }
        var result = updateEntry(newEntry, this.stack[namespace]);
        this.stack[namespace] = result[0];
        return result[0];
    };
    SelectiveObjectReuse.prototype.dispose = function (namespace) {
        if (namespace === void 0) { namespace = null; }
        if (namespace) {
            delete this.stack[namespace];
        }
        else {
            this.stack = {};
        }
    };
    return SelectiveObjectReuse;
}());
exports.SelectiveObjectReuse = SelectiveObjectReuse;
//# sourceMappingURL=SelectiveObjectReuse.js.map